import './toggle_section.less';

import React, { Component } from 'react';
import PropTypes from 'prop-types';

import Toggle from './toggler.jsx';
import Tooltip from './tooltip.jsx';


class ToggleSection extends Component {

  render() {

    const { disabled, disabledReason, explanation } = this.props;

    return (
      <div className="toggle-section">

        <div className="field-description-container">

          <div className="field-name">
            {this.props.name}
            {
              !this.props.tooltip ? null :
              <Tooltip value={this.props.tooltip} />
            }
          </div>
          <div className="field-explanation">
            {
              explanation
            }
          </div>   
        </div>
        <div className="toggler-container">
          <Toggle
            checked={this.props.checked } 
            onChange={this.props.onChange} 
            disabled={disabled}
            disabledReason={disabledReason} />
        </div>
      </div>

    );
  }
}


ToggleSection.propTypes = {
  name: PropTypes.node,
  explanation: PropTypes.node,
  checked: PropTypes.bool.isRequired,
  onChange: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  disabledReason: PropTypes.node
};


export default ToggleSection;
